import "babel-polyfill";

import Vue from "vue";
import Vuetify from "vuetify";

// Translation provided by Vuetify (typescript)
// import en from "vuetify/es5/locale/en";
// import de from "vuetify/es5/locale/en";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import "./stylus/main.styl";

import moment from "moment";
Vue.prototype.moment = moment;

import Auth from "./services/auth";
import App from "./App.vue";
import routes from "./routes";
import VueRouter from "vue-router";
import store from "./store/index";
import "./registerServiceWorker";
import firebase from "firebase";
// import VueMouseflow from "vue-mouseflow";
import VueI18n from "vue-i18n";

Vue.config.productionTip = false;

console.log(`Application Informations:
Pipeline: ${process.env.VUE_APP_CI_PIPELINE_ID || "no pipeline info"}
Job: ${process.env.VUE_APP_CI_JOB_ID || "no build info"}
Branch: ${process.env.VUE_APP_CI_COMMIT_REF_NAME || "no branch info"}
Commit: ${process.env.VUE_APP_CI_COMMIT_SHA || "no commit info"}
Tag: ${process.env.VUE_APP_CI_COMMIT_TAG || "no tag info"}
Env: ${process.env.NODE_ENV}`);

/*
  User plugin, provides short-circuits to user data inside vue components.-
  Eg.
    * if (this.$user.isAdmin) { ... }
    * {{ $user.displayName }}
*/

const VueUser = {
  install: function(Vue) {
    Vue.prototype.$user = {
      displayName: () => Auth.userDisplayName(),
      avatar: () => Auth.getUserAvatar(),
      id: () => Auth.getUserId(),
      email: () => Auth.getUserEmail()
      // isAdmin: () => Auth.isAdmin(),
      // isKeyUser: () => Auth.isKeyUser(),
      // isSuperAdmin: () => Auth.isSuperAdmin(),
      // username: () => Auth.getUserName()
    };
  }
};

Vue.use(VueUser);

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: routes,
  linkActiveClass: "is-active"
});

async function authorize(to, from, next) {
  if (await Auth.isSignedIn()) {
    if (await Auth.stateLoaded()) {
      return next();
    }
  }

  let redirect = {
    path: "/signin"
  };

  if (to.fullPath !== "/") {
    redirect.query = { redirect: to.fullPath };
  }

  return next(redirect);
}

//NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  console.log("BEFORE EACH: START LOADING");
  store.dispatch("app/setLoading", true);
  let isAuthorized = await Auth.isSignedIn();
  let allowsAnonymous = !!to.matched.some(
    route => route.meta.anonymous === true
  );

  let allowsAuthorized = true;
  if (to.matched.some(r => r.meta.hasOwnProperty("authorized"))) {
    allowsAuthorized = !to.matched.some(
      route => route.meta.authorized === false
    );
  }

  if (isAuthorized) {
    let isStateLoaded = await Auth.stateLoaded();
    if (isStateLoaded) {
      if (allowsAuthorized) {
        //NProgress.start()
        return next();
      }

      // NProgress.start()
      return next({ path: "/" });
    }
  }

  if (allowsAnonymous) {
    //NProgress.start()
    return next();
  }

  return await authorize(to, from, next);
});

// It seems that the beforeResolve Hook is to late to display a propper loading indicator
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  //NProgress.start()
  if (to.name) {
    // Start the route progress bar.
    //NProgress.start()
    store.dispatch("app/setLoading", true);
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  //NProgress.done()
  store.dispatch("app/setLoading", false);
  console.log("AFTER EACH: STOP LOADING", to, from);
});

Vue.use(VueI18n);

const messages = {
  en: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: "Items per page:",
        rowsPerPageAll: "All",
        pageText: "{0}-{1} of {2}",
        noResultsText: "No matching records found",
        nextPage: "Next page",
        prevPage: "Previous page"
      },
      dataTable: {
        rowsPerPageText: "Rows per page:"
      },
      noDataText: "No data available"
    }
  },
  de: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: "Elemente pro Seite:",
        rowsPerPageAll: "Alle",
        pageText: "{0}-{1} von {2}",
        noResultsText: "Keine Elemente gefunden",
        nextPage: "Nächste Seite",
        prevPage: "Vorherige Seite"
      },
      dataTable: {
        rowsPerPageText: "Zeilen pro Seite:"
      },
      noDataText: "Keine Daten vorhanden"
    }
  }
};

const i18n = new VueI18n({
  locale: "en",
  messages: messages,
  silentTranslationWarn: true
});

Vue.use(Vuetify, {
  theme: {
    primary: "#0097A7",
    "dark-primary": "#0097A7",
    "default-primary": "#00BCD4",
    "light-primary": "#B2EBF2",
    "text-primary": "#FFFFFF",
    accent: "#FFC107",
    "primary-text": "#212121",
    "secondary-text": "#757575",
    divider: "#BDBDBD"
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});

// TODO: make Mouseflow configurable
// Vue.use(VueMouseflow, { tracking_key: "6ae18b57-da4c-4e0f-9e5c-97780adb3cd4" });
window.TheFirebase = firebase.initializeApp(
  JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG)
);
console.log("Firebase Config", process.env.VUE_APP_FIREBASE_CONFIG);

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});

const startApp = () => {
  return new Vue({
    router,
    store,
    i18n: i18n,
    render: h => h(App),
    created() {
      firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          console.log("FIREBASE AUTO");
          console.log(user);
          await this.$store.dispatch("app/setStatus", {});
          await this.$store.dispatch("users/autoSignIn", user);
          await this.$store.dispatch("configuration/loadData");
          await this.$store.dispatch("autocompletes/loadAutoCompletesData");
          await this.$store.dispatch("users/loadUsers");
          await this.$store.dispatch("users/loadRoles");
          await this.$store.dispatch("audits/loadMeasures");
          await this.$store.dispatch("standards/loadStandards");
          await this.$store.dispatch("templates/loadAudits");
          await this.$store.dispatch(
            "activities/loadActivities",
            this.$user.id()
          );
        }
      });
    }
  }).$mount("#app");
};

// window.TheAuditCloud = startApp(); /*

firebase
  .firestore()
  .enablePersistence({ synchronizeTabs: true })
  .catch(err => {
    console.error("firestore enablePersistence failed", err);
  })
  .then(() => {
    window.TheAuditCloud = startApp();
    console.log("firestore enablePersistence succeeded");
  });
// */

// Activate if using OAuth OpenID
/*firebase.initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG));

firebase.auth().onAuthStateChanged(user => {
  const url = window.location.href;
  if (user) {
    console.log("FIREBASE AUTO");
    console.log("Real Start");
    startApp(user);
  } else if (url.indexOf("jwt=") > -1) {
    // The minted firebase token from Auth function
    const token = url.substr(url.indexOf("jwt=") + 4);
    console.log("Token", token);
    firebase
      .auth()
      .signInWithCustomToken(token)
      .then(user => {
        console.log("User is there", user);
        window.location.href = "/";
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.error(errorCode + " " + errorMessage);
      });
  } else {
    console.log("Login Start")
    startApp();
  }
});

function startApp(user) {
  const myuser = user;
  new Vue({
    router,
    store,
    i18n: i18n,
    render: h => h(App),
    created() {
      firebase.auth().onAuthStateChanged(user => {
        this.$store.dispatch("users/autoSignIn", myuser);
        console.log("FETCH DATA");
        console.log("Firebase Config", process.env.VUE_APP_FIREBASE_CONFIG);
        this.$store.dispatch("configuration/loadData");
        this.$store.dispatch("users/loadUsers");
        this.$store.dispatch("users/loadRoles");
        this.$store.dispatch("audits/loadMeasures");
        this.$store.dispatch("standards/loadStandards");
        this.$store.dispatch("templates/loadAudits");
        this.$store.dispatch("activities/loadActivities", this.$user.id());
        this.$store.dispatch("app/setStatus", {});
      })
    }
  }).$mount("#app");
}*/
